function formatMoney(amount) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(amount);
  }
  return '$' + (amount / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function readCookie(name) {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name + '=') === 0) {
      return cookie.substring((name + '=').length, cookie.length);
    }
  }
  return false;
}

function getCookieDiscount() {
  var rawCookie = readCookie('discount_code');
  if (!rawCookie) {
    if (window.StrikepriceDiscount) {
      window.StrikepriceDiscount.code = null;
    }
    return 0;
  }

  var decodedCookie = decodeURIComponent(rawCookie);
  var code = decodedCookie.split(':')[0].trim();
  if (!code) {
    if (window.StrikepriceDiscount) {
      window.StrikepriceDiscount.code = null;
    }
    return 0;
  }

  window.StrikepriceDiscount = window.StrikepriceDiscount || {};

  var normalizedCode = code.toUpperCase();
  var knownDiscounts = {
    FIRSTPURCHASE30: 30,
    ASSUR35: 35
  };

  if (Object.prototype.hasOwnProperty.call(knownDiscounts, normalizedCode)) {
    window.StrikepriceDiscount.code = normalizedCode;
    return knownDiscounts[normalizedCode];
  }

  var percentMatch = normalizedCode.match(/(\d{1,3})(?!.*\d)/);
  if (percentMatch) {
    window.StrikepriceDiscount.code = normalizedCode;
    return parseInt(percentMatch[1], 10);
  }

  window.StrikepriceDiscount.code = normalizedCode;
  return 0;
}

function parsePriceToCents(value) {
  if (!value) {
    return 0;
  }
  var numeric = Number(String(value).replace(/[^0-9.-]+/g, ''));
  if (isNaN(numeric)) {
    return 0;
  }
  return Math.round(numeric * 100);
}

var discountIconMarkup = '<svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-discount" viewBox="0 0 24 24"><path d="M22.707 12.293l-11-11A1.002 1.002 0 0 0 11 1H2a1 1 0 0 0-1 1v9c0 .265.105.52.293.707l11 11a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9zm6 8.414L8.586 13 10 11.586 14.414 16 13 17.414zm3-3L11.586 10 13 8.586 17.414 13 16 14.414z" fill="currentColor"></path></svg>';
var defaultQuantityDiscountTiers = [
  { minQty: 10, percent: 15, label: 'QTY 10+' },
  { minQty: 5, percent: 10, label: 'QTY 5+' },
  { minQty: 3, percent: 5, label: 'QTY 3+' }
];

document.addEventListener('DOMContentLoaded', function () {
  var priceList = document.querySelector('[data-block-id="price"] price-list');
  if (!priceList) {
    return;
  }

  var salePriceElement = priceList.querySelector('sale-price');
  if (!salePriceElement) {
    return;
  }

  var comparePriceElement = priceList.querySelector('compare-at-price');
  var discountBadge = priceList.querySelector('.badge');

  function getPrimaryQuantityInput() {
    var specific = document.querySelector('[data-product-quantity] .quantity-selector__input');
    if (specific) {
      return specific;
    }
    return document.querySelector('.quantity-selector__input');
  }

  function getCurrentQuantity() {
    var field = getPrimaryQuantityInput();
    if (field && field.value) {
      return field.value;
    }
    return 1;
  }

  var quantityInput = getPrimaryQuantityInput();
  var cookieDiscount = getCookieDiscount();
  var currentVariant = null;
  var originalProductPrice = parsePriceToCents(salePriceElement.innerText);

  window.StrikepriceDiscount = window.StrikepriceDiscount || {};
  if (cookieDiscount > 0) {
    window.StrikepriceDiscount.discount = cookieDiscount;
  } else if (typeof window.StrikepriceDiscount.discount !== 'number') {
    window.StrikepriceDiscount.discount = 0;
  }

  function getQuantityDiscountTiers() {
    if (window.StrikepriceDiscount && Array.isArray(window.StrikepriceDiscount.quantityTiers)) {
      return window.StrikepriceDiscount.quantityTiers.slice().sort(function (a, b) {
        return (b.minQty || 0) - (a.minQty || 0);
      });
    }
    return defaultQuantityDiscountTiers;
  }

  function resolveQuantityDiscount(quantity) {
    var tiers = getQuantityDiscountTiers();
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (quantity >= tier.minQty) {
        return tier;
      }
    }
    return null;
  }

  function resolveBaseDiscount() {
    if (typeof window.StrikepriceDiscount.discount === 'number') {
      return window.StrikepriceDiscount.discount;
    }
    return 0;
  }

  function resolveVariantPrice(variant) {
    if (variant && typeof variant.price === 'number') {
      currentVariant = variant;
      originalProductPrice = variant.price;
      return variant.price;
    }
    if (currentVariant && typeof currentVariant.price === 'number') {
      return currentVariant.price;
    }
    return originalProductPrice;
  }

  function ensureComparePriceElement() {
    if (!comparePriceElement) {
      comparePriceElement = document.createElement('compare-at-price');
      comparePriceElement.className = 'h5 text-subdued line-through';
      priceList.append(comparePriceElement);
    }
    comparePriceElement.style.display = 'flex';
    return comparePriceElement;
  }

  function ensureDiscountBadge() {
    if (!discountBadge) {
      discountBadge = document.createElement('span');
      discountBadge.className = 'discount-badge text-xs';
      priceList.append(discountBadge);
    }
    discountBadge.style.display = 'flex';
    return discountBadge;
  }

  function hideStrikeElements() {
    salePriceElement.classList.remove('text-on-sale');
    salePriceElement.classList.add('text-subdued');
    if (comparePriceElement) {
      comparePriceElement.style.display = 'none';
    }
    if (discountBadge) {
      discountBadge.style.display = 'none';
    }
  }

  function setStrikePrice(variant, quantity, baseDiscount) {
    var variantPrice = resolveVariantPrice(variant);
    if (!variantPrice) {
      return;
    }

    var resolvedQuantity = parseInt(quantity, 10);
    if (isNaN(resolvedQuantity) || resolvedQuantity < 1) {
      resolvedQuantity = 1;
    }

    var discountPercent = typeof baseDiscount === 'number' ? baseDiscount : 0;

    var quantityTier = resolveQuantityDiscount(resolvedQuantity);
    if (quantityTier) {
      discountPercent += quantityTier.percent;
    }

    if (discountPercent <= 0) {
      salePriceElement.innerHTML = '<span class="sr-only">Sale price</span>' + formatMoney(variantPrice);
      hideStrikeElements();
      return;
    }

    var discountAmount = Math.round(variantPrice * (discountPercent / 100));
    var discountedVariantPrice = Math.max(variantPrice - discountAmount, 0);

    salePriceElement.classList.remove('text-subdued');
    salePriceElement.classList.add('text-on-sale');
    salePriceElement.innerHTML = '<span class="sr-only">Sale price</span>' + formatMoney(discountedVariantPrice);

    var compareElement = ensureComparePriceElement();
    compareElement.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(variantPrice);

    var badgeElement = ensureDiscountBadge();
    var labelParts = [];
    var detailParts = [];
    if (quantityTier && quantityTier.label) {
      detailParts.push('<small>' + quantityTier.label + '</small>');
    }
    if (window.StrikepriceDiscount && window.StrikepriceDiscount.code) {
      detailParts.push('<small>' + window.StrikepriceDiscount.code + '</small>');
    }

    var textLabel = discountPercent + '%';
    if (detailParts.length) {
      textLabel += ' ' + detailParts.join(' ');
    }

    badgeElement.innerHTML = discountIconMarkup + ' ' + textLabel;
  }

  document.addEventListener('variant:change', function (event) {
    setStrikePrice(event.detail && event.detail.variant, 1, resolveBaseDiscount());
  });

  var quantityButtons = document.querySelectorAll('quantity-selector > button');
  quantityButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      window.requestAnimationFrame(function () {
        var selector = button.closest('quantity-selector');
        var field = selector ? selector.querySelector('.quantity-selector__input') : getPrimaryQuantityInput();
        var quantityValue = field ? field.value : getCurrentQuantity();
        setStrikePrice(null, quantityValue, resolveBaseDiscount());
      });
    });
  });

  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      setStrikePrice(null, quantityInput.value, resolveBaseDiscount());
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('quantity-selector__input')) {
      setStrikePrice(null, event.target.value, resolveBaseDiscount());
    }
  });

  setStrikePrice(null, getCurrentQuantity(), resolveBaseDiscount());

  if (cookieDiscount) {
  var discountAlertElement = document.createElement('div');
    discountAlertElement.style.width = 'fit-content';
    discountAlertElement.style.margin = '0.5rem auto';
    discountAlertElement.style.padding = '0.25rem 1rem';
    discountAlertElement.style.textAlign = 'center';
    discountAlertElement.style.fontWeight = 'bold';
    discountAlertElement.style.color = 'orange';
    discountAlertElement.textContent = 'YOU QUALIFY FOR AN ADDITIONAL ' + cookieDiscount + '% OFF AT CHECKOUT';
    var addToCartForm = document.querySelector('form[action="/cart/add"]');
    if (addToCartForm) {
      addToCartForm.append(discountAlertElement);
    }
  }
});